export default __webpack_public_path__ + "static/media/design-choice.519a0db8.png";